import { render, staticRenderFns } from "./shopa.vue?vue&type=template&id=dc1a859e&scoped=true&"
import script from "./shopa.vue?vue&type=script&lang=js&"
export * from "./shopa.vue?vue&type=script&lang=js&"
import style0 from "./shopa.vue?vue&type=style&index=0&id=dc1a859e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1a859e",
  null
  
)

export default component.exports